/**
 * Canonical payment-method codes stored in the database, in dropdown order.
 * The display label for each is resolved through i18n (see paymentMethodLabel).
 */
export const PAYMENT_METHOD_CODES = [
  'website_payment',
  'credit_card_verifone',
  'bank_transfer_deposit',
  'cash',
]

/**
 * Localized display label for a stored payment-method value.
 * Known codes resolve via the `paymentMethods` i18n namespace; any unknown or
 * legacy string (e.g. 'Online Transfer', 'Unknown') falls back to itself.
 *
 * @param {string|null|undefined} value — stored payment_method value
 * @param {(key: string, opts?: object) => string} t — i18next t function
 * @returns {string|null} localized label, or null when value is falsy
 */
export function paymentMethodLabel(value, t) {
  if (!value) return null
  return t(`paymentMethods.${value}`, { defaultValue: value })
}
